// Translations for the Spurna Creativa website
// Spanish (es) is the main language, English (en) is the secondary

export const translations = {
  es: {
    // Navigation
    nav: {
      filosofia: "FILOSOFÍA",
      proyectos: "PROYECTOS",
      publicidad: "PUBLICIDAD",
      queHacemos: "QUÉ HACEMOS",
      hablemos: "HABLEMOS",
      legal: "LEGAL",
    },
    
    // Home page
    home: {
      headline1: "La visión enciende la chispa.",
      headline2: "La IA aviva el fuego.",
      showreelCreativo: "VER REEL NARRATIVO",
      showreelIA: "VER REEL PUBLICITARIO",
      clientsTitle: "ALGUNOS DE NUESTROS CLIENTES",
      scroll: "Scroll",
    },
    
    // Filosofía page
    filosofia: {
      section1Title: "Vivimos conectados a la",
      section1Highlight: "Creatividad",
      section2Title: "Priorizamos la narrativa.",
      section2Text: "En un mundo donde el efectismo visual va en aumento, cuando todo sea artificio sólo importará la historia.",
      section3Title: "La IA es la herramienta para que lo imaginado aparezca.",
      section3Text: "La aplicamos para ampliar el relato, nunca como mero espectáculo.",
    },
    
    // Qué hacemos page
    queHacemos: {
      pageTitle: "Qué hacemos",
      services: {
        direccion: {
          title: "Dirección audiovisual",
          description: "Desde el concepto inicial hasta la entrega final. Audiovisuales y piezas narrativas reales o con IA."
        },
        guion: {
          title: "Guion",
          description: "Escritura de guiones de ficción y creatividad narrativa multiformato (cine, redes, vertical, streaming)"
        },
        musica: {
          title: "Música",
          description: "Creación de banda sonora y canciones específicas con inteligencia artificial."
        },
        formacion: {
          title: "Formación",
          description: "Formaciones sobre storytelling e inteligencia artificial."
        },
        consultoria: {
          title: "Consultoría",
          description: "Asesoramiento para proyectos con IA. Script Doctor."
        },
        iaEdits: {
          title: "IA Edits",
          description: "Apoyo con IA a la postproducción."
        }
      },
      process: {
        title: "Nuestro proceso",
        step1: { title: "Escucha", description: "Entendemos tu visión, tus objetivos y el contexto de tu proyecto." },
        step2: { title: "Concepto", description: "Desarrollamos la estrategia creativa y el enfoque narrativo." },
        step3: { title: "Producción", description: "Ejecutamos con rigor técnico y sensibilidad artística." },
        step4: { title: "Entrega", description: "Finalizamos y optimizamos para cada plataforma y uso." }
      },
      cta: {
        title: "¿Empezamos?",
        text: "Cuéntanos qué tienes en mente. Estaremos encantados de explorar cómo podemos ayudarte.",
        button: "Hablemos"
      }
    },
    
    // Hablemos page
    hablemos: {
      pageTitle: "Hablemos",
      introText: "Si tienes un proyecto en mente o quieres conocernos mejor, escríbenos.",
      centralText: "Nos encantará crear contigo",
      contactTitle: "Contacto",
      quote: "El mundo es un lienzo para nuestra imaginación.",
      quoteAuthor: "Henry David Thoreau",
      form: {
        name: "Nombre",
        company: "Empresa",
        email: "Email",
        phone: "Teléfono",
        message: "¿En qué podemos ayudarte?",
        newsletter: "Deseo recibir notificaciones informativas",
        submit: "Enviar mensaje",
        success: "¡Mensaje enviado! Nos pondremos en contacto contigo pronto.",
        error: "Error al enviar el mensaje. Por favor, inténtalo de nuevo.",
      },
    },
    
    // Proyectos page
    proyectos: {
      heroTitle: "Ficción con IA",
      introQuote: "Nuestros proyectos nacen de la pulsión siempre conectada con la fuente de la creatividad. La IA es sólo la herramienta al servicio del creador.",
      hybridProject: "Proyecto híbrido, imagen real + IA",
      avatarText: "Creación de avatares únicos y realistas\npara publicidad, branded content o entretenimiento",
      musicVideosTitle: "Music Videos",
      musicVideosText: "Creación de vídeos musicales y creación completa\nde proyectos musicales con IA",
      ficcionReal: "Ficción real",
      featureFilmProject: "Proyecto de largometraje.",
      featureFilmDrama: "Largometraje de ficción – Drama",
      featureFilmSciFi: "Largometraje de drama – ciencia ficción",
      shelter: "SHELTER. Cortometraje. 2026.\nFinalist in Ai film Awards India\nFinalist in Ai film fest Monaco\nFairground tv Top 16 Grand Finalist",
      theDevours: "THE DEVOURS. Piloto de serie. 2026.",
      pedroMosquito: "PEDRO MOSQUITO. 2026. Serie de comedia (IP) de Spurna Creativa.",
      eusebioMerlay: "Eusebio Merlay. Mini serie divulgativa Kids & Family sobre ciencia. 2025",
      myLastExorcism: "My last exorcism. Cortometraje. Principios 2025",
      skateAroundWorld: "SKATE AROUND THE WORLD. 2026. Travel IP. Episode 2: Monaco.",
      socBarcelona: "Soc de Barcelona. Mediados 2025. Proyecto de serie vertical distópica.\nGanador en el certamen ReelShort Impact con el premio Visionary Award",
      puDrenpa: "Pu Drénpa. Mediados 2025. Falso documental.\nGanador en el certamen ReelShort Impact con el premio Visionary Award",
      unthinkableAlien: "Unthinkable Alien. Mediados 2025. Cortometraje.",
      woodyAlien: "Woody Alien. Mediados 2025.\nProyecto de serie de humor & ciencia ficción",
      chatGptEngana: "ChatGPT me engaña",
      miniSerieHumor: "Mini serie de humor. Principios de 2025",
      doloresRainbowGame: "Dolores Rainbow. Game tester Avatar. Mediados 2025",
      elTremendista: "EL TREMENDISTA. (2026). Influencer IP.",
      gregBucka: "GREG BUCKA. (2026). Influencer IP.",
      stillnessInTheDust: "STILLNESS IN THE DUST (2026).",
      leapOfFaith: "LEAP OF FAITH (2026).",
      fionaMont: "Fiona Mont. Video Musical: Aureli Prats.\nPrincipios de 2026.\nProyecto discográfico con Cantante IA Catalana",
      orthodox: "Orthodox. Video musical. Principios de 2025.\nMención honorífica en el Chroma Awards 2025",
      loglineLabel: "Logline:",
      loglineText: "Un creador en crisis emocional y artística se enfrenta al bloqueo, al amor y a la necesidad de reconciliarse con su propia mirada mientras la historia que escribe empieza a reflejar, de forma inquietante, su propio proceso vital.",
      themesLabel: "Temas:",
      porUnaNubeThemes: [
        "El proceso creativo como conflicto vital",
        "Amor, dependencia y miedo a la pérdida",
        "Identidad y búsqueda de sentido",
        "La necesidad de aceptar la imperfección",
        "La dificultad de cerrar ciclos",
        "La relación entre autor y obra"
      ],
      awardsLabel: "Premios y reconocimientos en guion:",
      porUnaNubeAwards: [
        "Capital Fund Screenplay Competition (Hollywood) – Top 100",
        "Creative World Awards – Semi-finalist",
        "Big Apple Film Festival – Semi-finalist",
        "Finish Line Script Competition – Quarter-finalist"
      ],
      porUnaNubeCoprod: "Por una nube es una coproducción internacional entre España y México, lo que potencia su proyección en circuitos iberoamericanos y mercados latinoamericanos.",
      porUnaNubeProducer: "Production Friendly - Productor asociado – México.",
      porUnaNubeSearch: "En fase de búsqueda de coproductor español.",
      kintsukuroiThemes: [
        "La reparación emocional y la belleza de lo imperfecto",
        "Amor, dependencia y miedo a la pérdida",
        "Identidad, culpa y necesidad de perdón",
        "Intimidad, confianza y límites en la pareja",
        "Trauma, memoria y lo que no se dice",
        "La posibilidad de renacer sin borrar la cicatriz",
        "Lo cotidiano como territorio de lo extraordinario"
      ],
      kintsukuroiAwards: [
        "WRPN.tv Gold Script Writing Award — Gold Award Winner (Spring 2025)",
        "Los Angeles International Screenplay Awards (2025) — Quarterfinalist",
        "Faith in Film Screenwriting Competition (2025) — Quarterfinalist",
        "Austin Film Festival (2025) — Second Rounder"
      ],
    },
    
    // Publicidad page
    publicidad: {
      heroTitle: "Publicidad con IA",
      introText: "La ficción es nuestro lenguaje natural, pero también contamos historias para las marcas. Aplicamos la misma exigencia narrativa y visual que en nuestros proyectos cinematográficos a la creación de campañas y piezas de publicidad impulsadas por inteligencia artificial",
      memoryOfScents: "MEMORY OF SCENTS. Spec ad de Chanel Nº5. 2026. Spurna Creativa.",
      cocaCola: "COCA-COLA. Spec ad de Coca-Cola. 2026. Spurna Creativa.",
      neurobyte: "NEUROBYTE. 2026. Spec ad dirigido por Roger Delmont.",
      whenMonster: "WHEN A MONSTER MERGES IN THE RAIN. Spec ad de Flor de Salt. 2026. Spurna Creativa.",
      paca: "PACA. 2017. Animación tradicional. Dirigido por Roger Delmont.",
    },
    
    // Legal page
    legal: {
      pageTitle: "Legal",
      dataProtectionTitle: "Protección de Datos y Privacidad",
      dataProtectionIntro: "Spurna Creativa SL (\"nosotros\", \"nos\", \"nuestro\") es el responsable del tratamiento de datos de tu información personal y se compromete a protegerla de conformidad con el Reglamento General de Protección de Datos (RGPD) de la UE/Reino Unido, la LGPD de Brasil, la APPI de Japón, la PIPEDA de Canadá y, cuando proceda, la CCPA/CPRA de California.",
      questionsEmail: "¿Preguntas o solicitudes?",
      whatWeCollectTitle: "Qué recopilamos y por qué",
      whatWeCollectText: "No recopilamos información personal a través de formularios en el sitio web. Para colaboraciones, nos ponemos en contacto directamente con potenciales clientes a través de email o LinkedIn. Los únicos datos que recopilamos automáticamente son datos técnicos de uso (dirección IP, tipo de navegador, páginas visitadas) para mantener la seguridad del sitio y mejorar tu experiencia.",
      cookiesTitle: "Cookies y consentimiento",
      cookiesText: "Utilizamos cookies técnicas necesarias para que el sitio funcione correctamente. Puedes gestionar tus preferencias de cookies en los ajustes de tu navegador.",
      yourRightsTitle: "Tus derechos",
      yourRightsIntro: "Tienes derecho a:",
      rights: [
        "Acceso — solicitar información sobre los datos personales que tenemos sobre ti",
        "Rectificación — corregir datos inexactos o incompletos",
        "Portabilidad — recibir tus datos en un formato portátil",
        "Derecho al olvido — solicitar la eliminación de tus datos",
        "Restricción del tratamiento — solicitar que pausemos el procesamiento",
        "Objeción — objetar el procesamiento de tus datos",
        "Retirar consentimiento — en cualquier momento"
      ],
      exerciseRights: "Para ejercer estos derechos, contáctanos a",
      tosTitle: "Términos de Servicio",
      tos1Title: "1. Uso del Sitio Web",
      tos1Text: "Este sitio web es operado por Spurna Creativa SL. Al acceder y usar este sitio, aceptas estar vinculado por estos Términos de Servicio.\n\nAceptas utilizar este sitio únicamente para fines legítimos y de manera que no viole los derechos de otros ni restrinja su uso y disfrute del sitio web. El comportamiento prohibido incluye hostigamiento o causación de angustia o inconvenientes, transmisión de obscenidades u contenido ofensivo, interrupción del flujo normal de diálogo dentro de nuestro sitio web.",
      tos2Title: "2. Propiedad Intelectual",
      tos2Text: "Todo el contenido incluido en este sitio web — incluyendo texto, gráficos, logos, imágenes, videos, archivos de audio y software — es propiedad de Spurna Creativa SL, de nuestros proveedores de contenido o de terceros y está protegido por leyes internacionales de derechos de autor.\n\nEl contenido mostrado en este sitio (nuestros proyectos creativos, vídeos, campañas publicitarias) es únicamente para propósitos de demostración de nuestro trabajo. No puedes reproducir, distribuir, transmitir, mostrar, realizar, reproducir o explotar ningún contenido de este sitio sin nuestro permiso expreso por escrito.",
      tos3Title: "3. Limitaciones de Responsabilidad",
      tos3Text: "El contenido de este sitio se proporciona \"tal cual\". No garantizamos que el contenido sea preciso, completo o esté actualizado. En la medida máxima permitida por la ley, Spurna Creativa SL no será responsable por ningún daño directo, indirecto, incidental o consecuente que surja de tu uso o incapacidad para usar este sitio.",
      tos4Title: "4. Enlaces Externos",
      tos4Text: "Este sitio puede contener enlaces a sitios web de terceros. No somos responsables del contenido, precisión o prácticas de privacidad de esos sitios externos. El acceso a sitios externos está bajo tu propio riesgo.",
      tos5Title: "5. Cambios en los Términos",
      tos5Text: "Nos reservamos el derecho de modificar estos Términos de Servicio en cualquier momento. Los cambios entrarán en vigor en el momento de su publicación en el sitio. Tu uso continuado del sitio después de los cambios constituye tu aceptación de los nuevos términos.",
      tos6Title: "6. Contacto",
      tos6Text: "Para consultas sobre estos Términos, contáctanos a",
      tos7Title: "7. Ley Aplicable",
      tos7Text: "Estos Términos de Servicio se rigen por las leyes de España.",
      privacyTitle: "Política de Privacidad",
      privacyLastUpdate: "Última actualización: 18 de junio de 2026",
      privacy1Title: "1. Introducción",
      privacy1Text: "Spurna Creativa SL (\"nosotros\", \"nos\", \"nuestro\") respeta tu privacidad. Esta Política de Privacidad explica cómo recopilamos, utilizamos y compartimos tu información personal cuando visitas nuestro sitio web o te comunicas con nosotros.",
      privacy2Title: "2. Información que Recopilamos",
      privacy2Text: "No recopilamos información personal a través de formularios en el sitio web. Únicamente recopilamos datos técnicos de uso de forma automática:",
      privacy2TechData: "Datos Técnicos (recopilados automáticamente):",
      privacy2TechItems: ["Dirección IP", "Tipo y versión de navegador", "Páginas visitadas", "Tiempo de visita", "Información del dispositivo"],
      privacy3Title: "3. Cómo Utilizamos Tu Información",
      privacy3Text: "Utilizamos tu información personal para:",
      privacy3Items: ["Responder a tus consultas y solicitudes", "Comunicarnos contigo sobre nuestros servicios", "Mantener y mejorar la seguridad del sitio", "Cumplir con obligaciones legales"],
      privacy4Title: "4. No Vendemos Tus Datos",
      privacy4Text: "Spurna Creativa SL no vende, alquila ni comparte tu información personal con terceros con fines comerciales. Solo compartimos información cuando es necesario para prestar nuestros servicios o cuando la ley lo requiere.",
      privacy5Title: "5. Seguridad",
      privacy5Text: "Tomamos medidas razonables para proteger tu información personal contra acceso no autorizado. Sin embargo, no podemos garantizar seguridad absoluta en la transmisión de datos a través de Internet.",
      privacy6Title: "6. Retención de Datos",
      privacy6Text: "Conservamos tu información personal solo durante el tiempo necesario para responder a tu consulta o cumplir con obligaciones legales. Después, eliminamos o anonimizamos tus datos.",
      privacy7Title: "7. Tus Derechos",
      privacy7Text: "Tienes derecho a:",
      privacy7Items: ["Acceder a los datos personales que tenemos sobre ti", "Corregir datos inexactos", "Solicitar la eliminación de tus datos", "Obtener una copia de tus datos en formato portátil", "Objetar el procesamiento de tus datos", "Retirar tu consentimiento en cualquier momento"],
      privacy7Exercise: "Para ejercer estos derechos, envíanos un email a",
      privacy8Title: "8. Cambios en la Política",
      privacy8Text: "Podemos actualizar esta Política de Privacidad en cualquier momento. Los cambios serán publicados en esta página con la fecha actualizada. Te recomendamos revisar esta política periódicamente.",
      privacy9Title: "9. Contacto",
      privacy9Text: "Si tienes preguntas sobre esta Política de Privacidad, contáctanos a:",
      dataControllerText: "Para fines de protección de datos, Spurna Creativa SL es el responsable del tratamiento de tu información personal.",
    },
    
    // Footer
    footer: {
      quote: "El mundo es un lienzo para nuestra imaginación.",
      quoteAuthor: "Henry David Thoreau",
      navigation: "Navegación",
      contact: "Contacto",
      copyright: "Todos los derechos reservados.",
      audiovisualProduction: "Producción audiovisual",
    },
    
    // Common
    common: {
      openMenu: "Abrir menú",
    }
  },
  
  en: {
    // Navigation
    nav: {
      filosofia: "PHILOSOPHY",
      proyectos: "PROJECTS",
      publicidad: "ADVERTISING",
      queHacemos: "WHAT WE DO",
      hablemos: "LET'S TALK",
      legal: "LEGAL",
    },
    
    // Home page
    home: {
      headline1: "Vision sparks the idea.",
      headline2: "AI fuels the flame.",
      showreelCreativo: "WATCH NARRATIVE REEL",
      showreelIA: "WATCH COMMERCIAL REEL",
      clientsTitle: "SOME OF OUR CLIENTS",
      scroll: "Scroll",
    },
    
    // Filosofía page
    filosofia: {
      section1Title: "We live connected to",
      section1Highlight: "Creativity",
      section2Title: "We prioritize narrative.",
      section2Text: "In a world where visual spectacle keeps growing, when everything becomes artifice, only the story will matter.",
      section3Title: "AI is the tool to bring imagination to life.",
      section3Text: "We use it to expand the story, never as mere spectacle.",
    },
    
    // Qué hacemos page
    queHacemos: {
      pageTitle: "What we do",
      services: {
        direccion: {
          title: "Audiovisual Direction",
          description: "From initial concept to final delivery. Real and AI-powered audiovisual and narrative pieces."
        },
        guion: {
          title: "Screenwriting",
          description: "Fiction screenwriting and multi-format narrative creativity (film, social media, vertical, streaming)"
        },
        musica: {
          title: "Music",
          description: "Original soundtrack and song creation using artificial intelligence."
        },
        formacion: {
          title: "Training",
          description: "Workshops on storytelling and artificial intelligence."
        },
        consultoria: {
          title: "Consulting",
          description: "Advisory services for AI projects. Script Doctor."
        },
        iaEdits: {
          title: "AI Edits",
          description: "AI-powered post-production support."
        }
      },
      process: {
        title: "Our process",
        step1: { title: "Listen", description: "We understand your vision, goals, and project context." },
        step2: { title: "Concept", description: "We develop the creative strategy and narrative approach." },
        step3: { title: "Production", description: "We execute with technical rigor and artistic sensitivity." },
        step4: { title: "Delivery", description: "We finalize and optimize for each platform and use." }
      },
      cta: {
        title: "Ready to start?",
        text: "Tell us what you have in mind. We'd love to explore how we can help you.",
        button: "Contact us"
      }
    },
    
    // Hablemos page
    hablemos: {
      pageTitle: "Let's Talk",
      introText: "If you have a project in mind or want to know us better, get in touch.",
      centralText: "We'd love to create with you",
      contactTitle: "Contact",
      quote: "The world is but a canvas to our imagination.",
      quoteAuthor: "Henry David Thoreau",
      form: {
        name: "Name",
        company: "Company",
        email: "Email",
        phone: "Phone",
        message: "How can we help you?",
        newsletter: "I wish to receive informative notifications",
        submit: "Send message",
        success: "Message sent! We will get back to you soon.",
        error: "Error sending message. Please try again.",
      },
    },
    
    // Proyectos page
    proyectos: {
      heroTitle: "AI Fiction",
      introQuote: "Our projects are born from a creative impulse always connected to the source of creativity. AI is simply the tool at the creator's service.",
      hybridProject: "Hybrid project, real footage + AI",
      avatarText: "Creation of unique, realistic avatars for advertising, branded content and entertainment.",
      musicVideosTitle: "Music Videos",
      musicVideosText: "Music video creation and complete development\nof AI-powered music projects",
      ficcionReal: "Real Fiction",
      featureFilmProject: "Feature film project.",
      featureFilmDrama: "Fiction feature film – Drama",
      featureFilmSciFi: "Drama – Science Fiction feature film",
      shelter: "SHELTER. Short film. 2026.\nFinalist in Ai film Awards India\nFinalist in Ai film fest Monaco\nFairground tv Top 16 Grand Finalist",
      theDevours: "THE DEVOURS. Series pilot. 2026.",
      pedroMosquito: "PEDRO MOSQUITO. 2026. IP comedy series by Spurna Creativa.",
      eusebioMerlay: "Eusebio Merlay. Kids & Family educational mini-series on science. 2025",
      myLastExorcism: "My Last Exorcism. Short film. Early 2025",
      skateAroundWorld: "SKATE AROUND THE WORLD. 2026. Travel IP. Episode 2: Monaco.",
      socBarcelona: "Soc de Barcelona. Mid 2025. Dystopian vertical series project.\nWinner at ReelShort Impact with the Visionary Award",
      puDrenpa: "Pu Drénpa. Mid 2025. Mockumentary.\nWinner at ReelShort Impact with the Visionary Award",
      unthinkableAlien: "Unthinkable Alien. Mid 2025. Short film.",
      woodyAlien: "Woody Alien. Mid 2025.\nComedy & sci-fi series project",
      chatGptEngana: "ChatGPT Tricks Me",
      miniSerieHumor: "Comedy mini-series. Early 2025",
      doloresRainbowGame: "Dolores Rainbow. Game Tester Avatar. Mid 2025",
      elTremendista: "EL TREMENDISTA. (2026). Influencer IP.",
      gregBucka: "GREG BUCKA. (2026). Influencer IP.",
      stillnessInTheDust: "STILLNESS IN THE DUST (2026).",
      leapOfFaith: "LEAP OF FAITH (2026).",
      fionaMont: "Fiona Mont. Music Video: Aureli Prats.\nEarly 2026.\nRecord project with Catalan AI Singer",
      orthodox: "Orthodox. Music video. Early 2025.\nHonorable mention at Chroma Awards 2025",
      loglineLabel: "Logline:",
      loglineText: "A creator in emotional and artistic crisis confronts writer's block, love, and the need to reconcile with his own perspective while the story he writes begins to disturbingly reflect his own life process.",
      themesLabel: "Themes:",
      porUnaNubeThemes: [
        "The creative process as a vital conflict",
        "Love, dependency, and fear of loss",
        "Identity and the search for meaning",
        "The need to accept imperfection",
        "The difficulty of closing cycles",
        "The relationship between author and work"
      ],
      awardsLabel: "Screenplay awards and recognition:",
      porUnaNubeAwards: [
        "Capital Fund Screenplay Competition (Hollywood) – Top 100",
        "Creative World Awards – Semi-finalist",
        "Big Apple Film Festival – Semi-finalist",
        "Finish Line Script Competition – Quarter-finalist"
      ],
      porUnaNubeCoprod: "Por una nube is an international co-production between Spain and Mexico, strengthening its projection in Ibero-American circuits and Latin American markets.",
      porUnaNubeProducer: "Production Friendly - Associate Producer – Mexico.",
      porUnaNubeSearch: "Currently seeking a Spanish co-producer.",
      kintsukuroiThemes: [
        "Emotional repair and the beauty of imperfection",
        "Love, dependency, and fear of loss",
        "Identity, guilt, and the need for forgiveness",
        "Intimacy, trust, and boundaries in relationships",
        "Trauma, memory, and what remains unsaid",
        "The possibility of rebirth without erasing the scar",
        "The everyday as territory of the extraordinary"
      ],
      kintsukuroiAwards: [
        "WRPN.tv Gold Script Writing Award — Gold Award Winner (Spring 2025)",
        "Los Angeles International Screenplay Awards (2025) — Quarterfinalist",
        "Faith in Film Screenwriting Competition (2025) — Quarterfinalist",
        "Austin Film Festival (2025) — Second Rounder"
      ],
    },
    
    // Publicidad page
    publicidad: {
      heroTitle: "AI Advertising",
      introText: "Fiction is our natural language, but we also tell stories for brands. We apply the same narrative and visual demands as in our film projects to the creation of AI-powered advertising campaigns and pieces",
      memoryOfScents: "MEMORY OF SCENTS. Chanel Nº5 spec ad. 2026. Spurna Creativa.",
      cocaCola: "COCA-COLA. Coca-Cola spec ad. 2026. Spurna Creativa.",
      neurobyte: "NEUROBYTE. 2026. Spec ad directed by Roger Delmont.",
      whenMonster: "WHEN A MONSTER MERGES IN THE RAIN. Flor de Salt spec ad. 2026. Spurna Creativa.",
      paca: "PACA. 2017. Traditional animation. Directed by Roger Delmont.",
    },
    
    // Legal page
    legal: {
      pageTitle: "Legal",
      dataProtectionTitle: "Data Protection and Privacy",
      dataProtectionIntro: "Spurna Creativa SL (\"we\", \"us\", \"our\") respects your privacy. We are the data controller responsible for your personal information and are committed to protecting it in accordance with the EU/UK General Data Protection Regulation (GDPR), Brazil's LGPD, Japan's APPI, Canada's PIPEDA, and, where applicable, California's CCPA/CPRA.",
      questionsEmail: "Questions or requests?",
      whatWeCollectTitle: "What We Collect and Why",
      whatWeCollectText: "We do not collect personal information through forms on the website. For collaborations, we contact potential clients directly through email or LinkedIn. The only data we collect automatically is technical usage data (IP address, browser type, pages visited) to maintain site security and improve your experience.",
      cookiesTitle: "Cookies and Consent",
      cookiesText: "We use technical cookies necessary for the site to function correctly. You can manage your cookie preferences in your browser settings.",
      yourRightsTitle: "Your Rights",
      yourRightsIntro: "You have the right to:",
      rights: [
        "Access — request information about the personal data we hold about you",
        "Rectification — correct inaccurate or incomplete data",
        "Portability — receive your data in a portable format",
        "Erasure — request deletion of your data",
        "Restriction of processing — request that we pause processing",
        "Objection — object to the processing of your data",
        "Withdraw consent — at any time"
      ],
      exerciseRights: "To exercise these rights, contact us at",
      tosTitle: "Terms of Service",
      tos1Title: "1. Website Use",
      tos1Text: "This website is operated by Spurna Creativa SL. By accessing and using this site, you agree to be bound by these Terms of Service.\n\nYou agree to use this site only for lawful purposes and in a way that does not violate the rights of others or restrict their use and enjoyment of the website. Prohibited behavior includes harassment or causing distress or inconvenience, transmission of obscene or offensive content, interruption of the normal flow of dialogue within our website.",
      tos2Title: "2. Intellectual Property",
      tos2Text: "All content included on this website — including text, graphics, logos, images, videos, audio files and software — is owned by Spurna Creativa SL, our content providers or third parties and is protected by international copyright laws.\n\nThe content displayed on this site (our creative projects, videos, advertising campaigns) is for demonstration purposes only to showcase our work. You may not reproduce, distribute, transmit, display, perform or exploit any content from this site without our express written permission.",
      tos3Title: "3. Limitations of Liability",
      tos3Text: "The content of this site is provided \"as is\". We do not guarantee that the content is accurate, complete or up to date. To the maximum extent permitted by law, Spurna Creativa SL will not be liable for any direct, indirect, incidental or consequential damages arising from your use or inability to use this site.",
      tos4Title: "4. External Links",
      tos4Text: "This site may contain links to third-party websites. We are not responsible for the content, accuracy or privacy practices of those external sites. Access to external sites is at your own risk.",
      tos5Title: "5. Changes to Terms",
      tos5Text: "We reserve the right to modify these Terms of Service at any time. Changes will take effect when posted to the site. Your continued use of the site after changes constitutes your acceptance of the new terms.",
      tos6Title: "6. Contact",
      tos6Text: "For inquiries about these Terms, contact us at",
      tos7Title: "7. Governing Law",
      tos7Text: "These Terms of Service are governed by the laws of Spain.",
      privacyTitle: "Privacy Policy",
      privacyLastUpdate: "Last updated: 18 June 2026",
      privacy1Title: "1. Introduction",
      privacy1Text: "Spurna Creativa SL (\"we\", \"us\", \"our\") respects your privacy. This Privacy Policy explains how we collect, use and share your personal information when you visit our website or communicate with us.",
      privacy2Title: "2. Information We Collect",
      privacy2Text: "We do not collect personal information through forms on the website. We only collect technical usage data automatically:",
      privacy2TechData: "Technical Data (collected automatically):",
      privacy2TechItems: ["IP address", "Browser type and version", "Pages visited", "Time of visit", "Device information"],
      privacy3Title: "3. How We Use Your Information",
      privacy3Text: "We use your personal information to:",
      privacy3Items: ["Respond to your inquiries and requests", "Communicate with you about our services", "Maintain and improve site security", "Comply with legal obligations"],
      privacy4Title: "4. We Do Not Sell Your Data",
      privacy4Text: "Spurna Creativa SL does not sell, rent or share your personal information with third parties for commercial purposes. We only share information when necessary to provide our services or when required by law.",
      privacy5Title: "5. Security",
      privacy5Text: "We take reasonable measures to protect your personal information from unauthorized access. However, we cannot guarantee absolute security in the transmission of data over the Internet.",
      privacy6Title: "6. Data Retention",
      privacy6Text: "We retain your personal information only for as long as necessary to respond to your inquiry or comply with legal obligations. After that, we delete or anonymize your data.",
      privacy7Title: "7. Your Rights",
      privacy7Text: "You have the right to:",
      privacy7Items: ["Access the personal data we hold about you", "Correct inaccurate data", "Request deletion of your data", "Obtain a copy of your data in portable format", "Object to the processing of your data", "Withdraw your consent at any time"],
      privacy7Exercise: "To exercise these rights, send us an email at",
      privacy8Title: "8. Changes to This Policy",
      privacy8Text: "We may update this Privacy Policy at any time. Changes will be posted on this page with the updated date. We recommend reviewing this policy periodically.",
      privacy9Title: "9. Contact",
      privacy9Text: "If you have questions about this Privacy Policy, contact us at:",
      dataControllerText: "For data protection purposes, Spurna Creativa SL is the data controller of your personal information.",
    },
    
    // Footer
    footer: {
      quote: "The world is but a canvas to our imagination.",
      quoteAuthor: "Henry David Thoreau",
      navigation: "Navigation",
      contact: "Contact",
      copyright: "All rights reserved.",
      audiovisualProduction: "Audiovisual production",
    },
    
    // Common
    common: {
      openMenu: "Open menu",
    }
  }
};

// Helper function to get translation
export const getTranslation = (lang, path) => {
  const keys = path.split('.');
  let result = translations[lang];
  for (const key of keys) {
    if (result && result[key]) {
      result = result[key];
    } else {
      return path;
    }
  }
  return result;
};
